<template>
	<div>
		<DotLoadingPage v-if="isRendering" />
		<TopicFormationDashboardLayout />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import TopicFormationDashboardLayout from '@/views/layouts/TopicFormationDashboardLayout.vue';
import DotLoadingPage from '../../components/dot-loading-page/DotLoadingPage.vue';

export default {
	name: 'TopicFormationDashboard',
	components: { DotLoadingPage, TopicFormationDashboardLayout },
	computed: {
		...mapGetters('appState', {
			isSwitchFormationStateLoading: 'isSwitchFormationStateLoading',
		}),
	},
	data() {
		return { isRendering: true };
	},
	mounted() {
		const duration = 5000;

		// The loading on this page is managed manually with a set duration. The status isSwitchFormationStateLoading allows us to check if another manual loading process is in progress.
		setTimeout(
			() => {
				this.isRendering = false;
			},
			this.isSwitchFormationStateLoading ? 0 : duration
		);
	},
};
</script>
